const CACHE_KEY = 'pwa-api-base';
const PROBE_PATHS = ['/api/healthz', '/api/readyz', '/api', '/'];
const FETCH_TIMEOUT = 2000;

function timeoutFetch(url: string, opts: any = {}, ms = FETCH_TIMEOUT) {
  return new Promise<Response>((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error('timeout')), ms);
    fetch(url, opts).then((r) => { clearTimeout(timer); resolve(r); }).catch((e) => { clearTimeout(timer); reject(e); });
  });
}

export function getCachedApiBase(): string | null {
  try { const v = localStorage.getItem(CACHE_KEY); return v || null; } catch { return null; }
}

export function setCachedApiBase(base: string | null) {
  try {
    if (!base) localStorage.removeItem(CACHE_KEY);
    else localStorage.setItem(CACHE_KEY, base);
  } catch {}
}

async function probeUrl(url: string) {
  try {
    const res = await timeoutFetch(url, { method: 'GET', mode: 'cors' }, FETCH_TIMEOUT);
    if (!res.ok) return false;
    const ct = (res.headers.get('content-type') || '').toLowerCase();
    // Accept JSON or plain text that is not HTML
    if (ct.indexOf('application/json') !== -1) return true;
    if (ct.indexOf('text/plain') !== -1) return true;
    // If content-type not provided, fetch small body and ensure it's not HTML
    const text = await res.text().catch(() => '');
    if (text && /<html|<!doctype/i.test(text)) return false;
    return true;
  } catch {
    return false;
  }
}

export async function discoverApiBaseOnce(): Promise<string | null> {
  const cached = getCachedApiBase();
  if (cached) return cached;

  if (typeof window === 'undefined') return null;
  const host = window.location.hostname;
  const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';

  // Known backend hosts (include the user's Render backend to prefer it)
  const KNOWN_BACKENDS = [
    `${protocol}//waitlist-api-ue77.onrender.com`,
  ];

  const candidates = [
    ...KNOWN_BACKENDS,
    '', // same-origin
    `${protocol}//api.${host}`,
    `${protocol}//backend.${host}`,
    `${protocol}//${host.replace(/^www\./,'api.')}`,
    `${protocol}//${host}:3001`,
  ];

  for (const cand of candidates) {
    for (const p of PROBE_PATHS) {
      try {
        const url = cand ? `${cand}${p}` : p;
        const ok = await probeUrl(url);
        if (ok) {
          setCachedApiBase(cand);
          return cand;
        }
      } catch {}
    }
  }

  return null;
}
